import { Adaa4DashboardsSummary } from "../models/adaa4-home-model";
import { Adaa4Dashboard } from "../services/adaa4-redirect-service";

export interface Adaa4HomeCard {
  id: string;
  title: string;
  value: number;
  trend: number | null;
  dashboard: Adaa4Dashboard;
  actualLabel: string;
}

const numberOrNull = (value: number | null | undefined): number | null => (typeof value === "number" ? value : null);

export const buildAdaa4HomeCards = (summary: Adaa4DashboardsSummary): Adaa4HomeCard[] => {
  const cards: Adaa4HomeCard[] = [];
  const { governmentPerformance, strategy, agenticAi } = summary;

  if (typeof governmentPerformance?.performance === "number") {
    cards.push({
      id: "government",
      title: "adaa4.government_performance",
      value: governmentPerformance.performance,
      trend: numberOrNull(governmentPerformance.performanceMovement),
      dashboard: "govDashboard",
      actualLabel: "adaa4.overall_performance",
    });
  }

  if (typeof strategy?.achievement === "number") {
    cards.push({
      id: "strategy",
      title: "adaa4.strategy_dashboard",
      value: strategy.achievement,
      trend: numberOrNull(strategy.achievementMovement),
      dashboard: "strategyDashboard",
      actualLabel: "adaa4.we_the_uae_2031_performance",
    });
  }

  if (typeof agenticAi?.visionScore === "number") {
    cards.push({
      id: "agentic",
      title: "adaa4.agentic_performance",
      value: agenticAi.visionScore,
      trend: null,
      dashboard: "agenticDashboard",
      actualLabel: "adaa4.performance",
    });
  }

  return cards;
};
